// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_ua-0";